module.exports = __webpack_public_path__ + "static/media/4.183237e2.JPG";